import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { Resource } from '@shared/resource/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class ResourceApiService {
  private readonly basePath = '/v.1/resources';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  getAll(): Observable<Resource[]> {
    return this.http.get<Resource[]>(this.basePath);
  }

  getById(id: string): Observable<Resource> {
    return this.http.get<Resource>(`${this.basePath}/${id}`);
  }

  create(data: Omit<Resource, '_id'>): Observable<Resource> {
    return this.http.post<Resource>(this.basePath, data);
  }

  edit(resource: Partial<Omit<Resource, '_id'> & {_id: string}>): Observable<Resource> {
    const {_id, ...rest} = resource;

    return this.http.put<Resource>(`${this.basePath}/${_id}`, rest);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }

  updateBulk(updates) {
    return this.http.put<any>('/v.1/resources', updates).pipe(
      map(({success, error, data}) => {
        if(success) {
          return data;
        }
        throw new Error(`${error}`);
      })
    );
  }
}
